import I18n from 'i18n-js';
import React, { Component } from 'react';
import { shape } from 'prop-types';
import defaultUser from '../../../assets/images/defaultUser.svg';
import { phoneNumberFormat } from '../../common/utils/format';

export default class MemberFromService extends Component {
  static propTypes = {
    member: shape().isRequired,
  };

  render() {
    const { member } = this.props;

    return (
      <li className="user">
        <div className="user-picture user__image">
          <div className="user-picture__image" style={{ backgroundImage: `url(${member.avatar || defaultUser})` }}></div>
        </div>
        <p className="user__name">{member.lastname} {member.firstname}</p>
        {member.address && (
          <p className="user__location">{member.address.zipcode} {member.address.city}</p>
        )}
        <div className="user__contact">
          <div>
            {member.phone && (
              <span className="info">
                {I18n.t('pages.services.member.label:phone')} : <a href={`tel:${member.phone}`} >{phoneNumberFormat(member.phone)}</a>
              </span>
            )}
            {member.mobile && (
              <span className="info">
                {I18n.t('pages.services.member.label:mobile')} : <a href={`tel:${member.mobile}`} >{phoneNumberFormat(member.mobile)}</a>
              </span>
            )}
            {member.email && (
              <span className="info">
                {I18n.t('pages.services.member.label:email')} : <a href={`mailto:${member.email}`} >{member.email}</a>
              </span>
            )}
          </div>
        </div>
        <p className="user__description">{member.comment || <i>{I18n.t('pages.services.member.no-comment')}</i>}</p>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/members/components/MemberFromService.js